export default __webpack_public_path__ + "static/media/newDelete.0cdb0b76.svg";